<template>
  <div class="container my-3">
    <WinnerAnnouncement group="group3" name="Team1" v-if="hasWinner" />

    <GroupsScoreboard />
    <div class="mb-5"></div>

    <RouterButton to="Achievements" label="Go to Achievements" icon="award" />

    <div class="mb-5"></div>

    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-12 col-lg-10 col-xl-9 col-xxl-8">
        <AchievementFeed />
      </div>
    </div>
  </div>
</template>

<script>
import WinnerAnnouncement from "@/components/WinnerAnnouncement.vue";
import GroupsScoreboard from "@/components/activity/GroupsScoreboard.vue";
import AchievementFeed from "@/components/activity/AchievementFeed.vue";
import RouterButton from "@/components/activity/RouterButton.vue";

export default {
  name: "HomeView",
  components: {
    WinnerAnnouncement,
    GroupsScoreboard,
    AchievementFeed,
    RouterButton
  },
  computed: {
    hasWinner() {
      return false; // Placeholder for actual winner logic
    }
  }
};
</script>
